import { Component, HostListener, Inject, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";
import { ClientLoggerService } from '../../services/client-logger.service';
import _ from 'lodash';
import { MySynchDataStore } from "../../data-stores/mysynch.datastore";
import { BroadCastService } from "../../services/broadcast.service";
import { PerformanceMetricsService } from "../../services/performance-metrics.service";
import { PerformanceContextService } from "../../services/performance-context.service";

import { PerformanceContext } from "../../interfaces/mysynch.interfaces";

@Component({
    standalone: false,
    selector:"account-header",
    templateUrl: "../app/headers/account-header/account-header.view.html",
})
export class AccountHeader implements OnInit, AfterViewInit, OnDestroy {
    private performanceContext: PerformanceContext | null = null;
    private authenticated:any;
    private user:any;
    private username:any;
    private personType:any;
    private userMenuLinks:any = [
        {
            name: 'User Profile',
            link: () => {
                this.MSF.loadPage('User');
            }
        }, {
            name: 'Log Out',
            link: ()=> {
                this.logout();
            }
        }
    ];

    private isMobile:boolean;
    private hideProfileButton:boolean = false;
    private userCookieCheckInterval:any = undefined;
    private currentUserSubscription:any;

    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ViewAuthorizationFactory') private viewAuth:any,
                @Inject('CookieFactory') private cookies:any, 
                @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
                @Inject(BroadCastService) private broadCastSrv:BroadCastService, 
                @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(ClientLoggerService) private log:ClientLoggerService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService) {
        this.isMobile = deviceDetector.isMobile();
    }

    // functions
        private initializeValues() {
            this.authenticated = this.viewAuth.checkUser();
            this.username = this.cookies.user.FirstName + ' ' + this.getUserLastNameDisplay(this.cookies.user.LastName);
        }
        private updateValues(){
         
            this.authenticated = this.viewAuth.checkUser();
            this.username = this.user.FirstName + ' ' + this.getUserLastNameDisplay(this.user.LastName);
        }


        private logout(){
            this.MSF.logout(() => {
                this.updateValues();
                this.MSF.loadPage('Login');
            });
        };

        private toggleMobileNavigation(){
            this.broadCastSrv.toggleNavigationMsg("");
        }

        private getUserLastNameDisplay(lastName){
            

            var territoryStart = _.indexOf(lastName,"(");
            var territoryEnd = _.indexOf(lastName,")");

            if(territoryStart > -1 && territoryEnd > -1){
            
                lastName = lastName.substr(0,territoryStart - 1);
            }

            return lastName;

        };

        private showLoginButton() {
            return !_.contains(['Login', 'WelcomeToFarm'], _.get(this.MSF, 'state.$current.name'));
        };

        login() {
            this.MSF.loadPage('Login');
        };
       //TODO: Figure out how to get account header to react to a user logging in/out 
       // logging in - > Login controller , logging out -> some times from MSF
       //  
       // $s.$on('user:changed', function refreshView() {
        //     updateValues();
        //     $timeout(function refreshViewInATick() {
        //         $s.$apply();
        //     }, 1);
        // });


        ngOnDestroy(){

            this.log.info("dashboard destroy called from account header.");
            if(!_.isUndefined(this.userCookieCheckInterval)){
                clearInterval(this.userCookieCheckInterval);
            }
            if(this.currentUserSubscription){
                this.currentUserSubscription.unsubscribe();
            }
            this.performanceContext = null;
        };
        ngOnInit(){
            this.MSF.ready(() => {
                this.performanceContext = this.perfContextSvc.createPerformanceContext();
                this.perfMetricSvc.startTiming("Component:AccountHeader:Render");
                //scope variables
                this.authenticated = this.viewAuth.checkUser();
                this.username = this.cookies.user.FirstName + ' ' + this.getUserLastNameDisplay(this.cookies.user.LastName);
            
                this.personType = _.find(this.MSF.lists.personType, {personTypeId: this.MSF.cookies.user.PersonTypeId});
                this.initializeValues();
                
    
                this.userCookieCheckInterval = setInterval(() =>{  
                                                    if(_.isEqual(this.viewAuth.checkUser(),false) && (!_.isUndefined(_.get(this.MSF,"cookies.user")) && _.any(_.keys(this.MSF.cookies.user),(key)=>{ return !_.isEmpty(this.MSF.cookies.user[key]);}) ) ){
                                                        this.logout();
                                                    }
                                                },30000);
                this.currentUserSubscription = this.mysynchDataStore.currentUser
                                     .subscribe((user)=>{
                                        if(!_.isUndefined(user)){
                                            this.user = user
                                            this.updateValues();        
                                        }
                                     });

               
            });
        }
        ngAfterViewInit(){
              this.MSF.ready(()=>{
                this.perfMetricSvc.endTiming("component","Component:AccountHeader:Render",this.performanceContext);
              });
        }
        @HostListener('document:click', ['$event'])
        documentClick(event){
            var userMenuIcon = $('#userMenuIcon');
            if(!userMenuIcon.hasClass('collapsed')){
                userMenuIcon.trigger('click');
            }
            
        }
       
}